import React, { Component } from 'react'

import style from './style.css'

class Modal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            active: '',
            fixBody: true,
            component: null
        }


        this.show = this.show.bind(this)
        this.hide = this.hide.bind(this)
    }

    componentDidMount() {
        this.eventListener = function(evt) {
            var keyCode = evt.keyCode ? evt.keyCode :
                evt.charCode ? evt.charCode :
                evt.which ? evt.which : void 0
            if (keyCode === 27) {
                this.hide()
                evt.stopPropagation()
                evt.preventDefault()
            }
        }.bind(this)

        window.addEventListener('keydown', this.eventListener)
    }
    componentWillUnmount(){
        window.removeEventListener('keydown', this.eventListener)
    }

    componentWillMount() {
        if(this.props.fixBody !== undefined)
        this.setState({ fixBody: this.props.fixBody })
    }
    
    fixBody() {
        var body = document.body || document.documentElement
        var scrollbarWidth = window.outerWidth - body.parentNode.offsetWidth   

        scrollbarWidth = scrollbarWidth + "px"
        body.style.overflow = 'hidden'
        body.style.paddingRight = scrollbarWidth
    }

    unFixBody() {
        var body = document.body || document.documentElement
        body.style.overflowY = 'scroll'
        body.style.paddingRight = ''
    }
    
    show() {
        if(this.state.fixBody)
            this.fixBody()
        
        this.setState({
            active: `${style.active}`,
            component: this.props.component
        })
    }

    hide() {
        if(this.state.fixBody)        
            this.unFixBody()

        this.setState({
            active: '',
            content: null
        })

        if(this.props.handleClose)
        this.props.handleClose()
    }

    ignoreClose(e) {
        e.stopPropagation()
    }

    render() {
        const content = () => {
            
            if(this.props.children)
                return (
                    this.props.children
                )
            

            if(this.state.component)
                return (
                    <this.props.component />
                )
            
        }
        
        return (
            <div className={`${style.modalContainer} ${this.state.active}`} onClick={this.hide}>
                <div className={style.modalClose} onClick={this.hide}>&#215;</div>
                <div className={style.modalTable}>
                    <div className={style.modalCell}>
                        <div
                            className={style.modalContent}
                            style={
                                {
                                    padding: this.props.padding || '60px',
                                    width: this.props.width || '445px',
                                }
                            }
                            onClick={this.ignoreClose}
                        >
                            {content()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Modal


// WEBPACK FOOTER //
// ./src/components/atoms/Modal/index.js